export const MPGE_ENGINES = ['electric', 'electric (fuel cell)', 'natural gas (CNG)'];
export const PAGE_DISPLAY_NAME = 'MPG & Gas Mileage Data';
export const ELECTRIC_PAGE_DISPLAY_NAME = 'MPGe & Electric Range Data';
export const URL_PATH = 'mpg';
export const CHANGE_VEHICLE_ID = 'change-mpg-vehicle';
